// extracted by mini-css-extract-plugin
module.exports = {"root":"_2vkfc","bg":"ej6dB","arrow":"_2WcMM"};